import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from 'src/app/utils/app-settings';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Error } from '../../models/error';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private http: HttpClient) { }

  uploadFile(file: File): Observable<any> {
    if (file) {
      let formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);
      return this.http.post(AppSettings.apiUrl + "file", formData).pipe(
        catchError(err => {
          if(err.status == 413){
            let errObj = new Error();
            errObj.status = err.status;
            errObj.statusText = err.statusText;
            errObj.message = "Please upload only files of size less than 10MB";
            return of(errObj);
          }
          throwError(err);
        })
        )
    }
    else {
      return of(null);
    }
  }
}
